import {
  http,
  delayIt,
  wrapAjax
} from "../utils/http";
const budgetAdmin = 'menu.budgetAdmin'; // 项目报价

const menuConfig = [{
  permission: 'api.budget.budgetList',
  p_permission: [budgetAdmin],
}, ];


// 暂时不用
export function getCurrentUser() {
  if (0) {
    return delayIt(() => {
      return {
        status: "succes",
      }
    }, )
  }

  function GetQueryString(name) {
    var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
    var r = window.location.hash.substr(1).match(reg); //search,查询？后面的参数，并匹配正则

    if (r != null) return unescape(r[2]);
    return null;
  }

  const code = GetQueryString('code');
  return http.post('/api/oa/auth-user', {
    code: code
  });
}

export function checkLogin() {
  return http.post('/api/oa/check-login-status');
}

export function getPermission() {
  const fixData = data => {
    let adminMenuStr = [];
    let adminMenu = [];
    data.list.forEach(item => {
      item.resource = item.resource.substr(1).split('/').join('.');
      let obj = menuConfig.find(child => child.permission === item.resource);
      if (obj && obj.p_permission) {
        obj.p_permission.forEach(c => {
          if (adminMenuStr.indexOf(c) === -1) {
            adminMenu.push({
              resource: c,
              role: '',
            })
          }
        })
      }
    });
    data.list = data.list.concat(adminMenu);
    data.list.map(item => {
      item.role = 'view';
    });
    let resources = {};
    const getRes = resource => (resources[resource] || (resources[resource] = {
      roles: {},
      actions: {},
      resources: {}
    }));

    data.list.map(({
      resource,
      role
    }) => {
      const res = getRes(resource);

      res.roles[role] = true;
    });
    return {
      resources,
      userName: data.name,
    }
  };
  const ajax = http.post('/api/oa/user-privileges');
  return wrapAjax(ajax, {
    fixData
  });
}

export function getCurrentPage(permission) {
  let menuRoute = [];
  let firstMenu = null;

  for (let key in permission) {
    if (menuConfig.find(item => key === item.permission) && !firstMenu) {
      firstMenu = key;
    }
    switch (key) {
      case 'api.budget.budgetList':
        menuRoute.push('budgetManage.teamBudget');
        menuRoute.push('budgetManage.teamBudgetDetail');
        break;
    }
  }
  let currentPage = '';
  switch (firstMenu) {
    case 'api.budget.budgetList':
      currentPage = 'budgetManage.teamBudget';
      break;
  }
  return {
    currentPage: currentPage,
    menuRoute: menuRoute
  };
}

export function logout() {
  return http.post(`/api/oa/logout`);
}